export {
  default as ContactCard2026,
  PhoneNumberReveal,
} from './contact-card-2026';
export type {
  ContactCard2026Props,
  ContactCardVariant,
} from './contact-card-2026';
